export interface VerifyUserResponse {
  token: string;
  refreshToken: string;
  userId: string;
  email: string;
}

export enum VerifyUserResponseStatusCodes {
  OtpExpired = 404,
  RegistrationNotFound = 403,
}
